import { Component, Inject, ViewChild, TemplateRef, ChangeDetectorRef, ViewRef } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { NativeDateAdapter } from '@angular/material/core';
import { MatDatepicker, MatDatepickerToggle } from '@angular/material/datepicker';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { Observable } from 'rxjs';
import { AuthenticationService } from '@app/core/services/AuthenticationService'
import { ICompany } from '@app/core/interfaces/ICompany';
import { ITimeReportStatus } from '@app/core/interfaces/invoice/TimeReportStatus';
import { InvoiceService } from '@app/core/services/InvoiceService';
import { CompanyService } from '@app/core/services/CompanyService';
import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';
import { UserService } from '@app/core/services/UserService';


@Component({
  standalone: false,
    selector: 'edit-customer-dialog',
    templateUrl: 'invoice-tool.calendarDialog.Component.html'
})

export class InvoiceToolCalendarDialogComponent {
    private _dimesionToggle = false;
    private _formValid = false;
    public _imageList: any[] = [];
    public _hasImages = false;
    private _showImageList = false;
    private _showAttachments = false;
    private _hasAttachments = false;
    private _showComments = false;
    public customer: ICompany;
    public isNewCustomer: boolean;
    @ViewChild('myInput', { static: false })
    myInputVariable: any;
    private _apiBaseUrl: string;
    @ViewChild("datepicker", { static: false }) datepicker: MatDatepicker<Date>;
    selectedDate: Date = new Date();
    private hoursList = [];
    private minutesList = [];
    private vatList = [];
    public rowTypeList = [];
    private hoursSelected: string = "8";
    private minutesSelected: string = "0";
    private rowTypeSelected: string = "0"
    private row: any = {};
    public selectedDates = [];
  public timeReportStatuses: Array<ITimeReportStatus> = [];
  public timeReportStatusesLoaded: boolean = false;
  public customerIsSweden: boolean = true;
  public countries: any[] = [{ Name: 'Sverige' }];
  public workCountry: string = '';
    isAdmin = false;
  ErrorMessageTab: string = "";
  quickrowValid: boolean = false;
  ErrorMessageDesc: string = "";
  ErrorMessageSend: string = "";
  canSave: boolean = true;
  isSaving: boolean = false;
  saveSubmitted: boolean = false;




  constructor(
        public dialogRef: MatDialogRef<InvoiceToolCalendarDialogComponent>,
        private authenticationService: AuthenticationService,
        private invoiceService: InvoiceService,
        private companyService: CompanyService,
        private userService: UserService,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private changeDetectorRef: ChangeDetectorRef
    ) 
    { 
        
    }

  ngOnInit() {
    
    this.isAdmin = this.userService.userHasRole("admin");
    this.getTimeReportStatuses();
    console.log(this.data.customerCountryName);
    this.customerIsSweden = this.data.customerCountryName != null && this.data.customerCountryName == "Sverige" ? true : false;

    // Create new group
    if (this.data.invoiceItemGroup == undefined || this.data.invoiceItemGroup == "")
    {
      this.data.invoiceItemGroup = { Id: this.guid(), Description: '', InvoiceRows: [], Type: {}, Vat: "25" };

      if (!this.customerIsSweden) {
        this.data.invoiceItemGroup = { Id: this.guid(), Description: '', InvoiceRows: [], Type: {}, Vat: "25" };
      }
    }

    this.data.invoiceItemGroup = JSON.parse(JSON.stringify(this.data.invoiceItemGroup));
    this.ensureInvoiceGroupDefaults();
    this.workCountry = this.getInitialWorkCountry();
    this.countries = [{ Name: this.workCountry || 'Sverige' }];
    this.loadCountries();
    if (this.isWorkedHoursGroup() && !this.data.invoiceItemGroup.WorkCountry) {
      this.data.invoiceItemGroup.WorkCountry = this.workCountry;
    }

    if (this.data.invoiceItemGroup.InvoiceRows != undefined) {
        for (var i = 0; i < this.data.invoiceItemGroup.InvoiceRows.length; i++) {
            const normalizedStartDate = this.normalizeDateOnly(this.data.invoiceItemGroup.InvoiceRows[i].StartDate);
            if (normalizedStartDate) {
              this.data.invoiceItemGroup.InvoiceRows[i].StartDate = normalizedStartDate;
            }
            this.data.invoiceItemGroup.InvoiceRows[i].HoursWorked = this.data.invoiceItemGroup.InvoiceRows[i].HoursWorked.toString();

            if (this.data.invoiceItemGroup.InvoiceRows[i].MinutesWorked != null)
            {
                this.data.invoiceItemGroup.InvoiceRows[i].MinutesWorked = this.data.invoiceItemGroup.InvoiceRows[i].MinutesWorked.toString();
            }
            else
            {
                this.data.invoiceItemGroup.InvoiceRows[i].MinutesWorked = "0";
            }
        }
    }

    for (var i = 0; i < 25; i++) {
        this.hoursList.push({ Value: i.toString() });
    }

    this.minutesList.push({ Value: "0" }, { Value: "15" }, { Value: "30" }, { Value: "45" });
    
    this.setVatList();
      
    this.rowTypeList.push({ Value: "1", Name: "Arbetad tid" }, { Value: "2", Name: "Övrigt" })

    this.selectedDates = [new Date('2018-10-28T11:13:59'), new Date('2018-10-27T11:13:59')];

    if (this.data.customer.TimeReportMandatory) {
      this.data.invoiceItemGroup.TimeReportStatus.Name = 'DetailedInfo';
    }

    this.updateValidationState();

  }

  private loadCountries() {
    this.companyService.getCountries().subscribe(
      response => {
        const loadedCountries = response || [];
        const selectedCountry = this.toCountryName(this.workCountry).trim();
        const countries = loadedCountries.length > 0
          ? [...loadedCountries]
          : [{ Name: this.workCountry || 'Sverige' }];

        if (selectedCountry !== '' && !countries.some(country => this.toCountryName(country?.Name).trim() === selectedCountry)) {
          countries.unshift({ Name: selectedCountry });
        }

        setTimeout(() => {
          this.countries = countries;
        }, 0);
      },
      () => {
        setTimeout(() => {
          this.countries = [{ Name: this.workCountry || 'Sverige' }];
        }, 0);
      }
    );
  }

  private getInitialWorkCountry(): string {
    if (this.data && this.data.invoiceItemGroup && this.data.invoiceItemGroup.WorkCountry) {
      return this.toCountryName(this.data.invoiceItemGroup.WorkCountry);
    }

    if (this.data && this.data.workCountry) {
      return this.toCountryName(this.data.workCountry);
    }

    if (this.data && this.data.customerCountryName) {
      return this.toCountryName(this.data.customerCountryName);
    }

    return 'Sverige';
  }

  private applyWorkCountryToGroup() {
    if (!this.isWorkedHoursGroup()) {
      return;
    }
    const selected = this.toCountryName(this.workCountry).trim();
    this.data.invoiceItemGroup.WorkCountry = selected !== '' ? selected : 'Sverige';
  }

  private toCountryName(value: any): string {
    if (value == null) {
      return '';
    }

    if (typeof value === 'string') {
      return value;
    }

    if (typeof value === 'object' && typeof value.Name === 'string') {
      return value.Name;
    }

    return String(value);
  }

  private isSwedishCustomer(): boolean {
    const countryName = this.toCountryName((this.data.customer && this.data.customer.Country && this.data.customer.Country.Name) || this.data.customerCountryName).trim().toLowerCase();
    const countryId = Number(this.data && this.data.customer && this.data.customer.Country ? this.data.customer.Country.Id : 0);
    return countryName === 'sverige' || countryId === 1;
  }

  private isEuCustomer(): boolean {
    return !this.isSwedishCustomer()
      && !!(this.data && this.data.customer && this.data.customer.Country && this.data.customer.Country.Eu === true);
  }

  isReverseTaxAllowed(): boolean {
    return this.isSwedishCustomer() && !!(this.data && this.data.customer && this.data.customer.IsCompany === true);
  }

  private getAllowedVatValues(): string[] {
    if (this.isAdmin) {
      return ['25', '12', '6', '0'];
    }

    if (this.isSwedishCustomer()) {
      return ['25', '12', '6'];
    }

    if (this.isEuCustomer()) {
      return ['0', '25'];
    }

    return ['0'];
  }

  private getDefaultVatValue(): string {
    if (this.isAdmin) {
      return '25';
    }

    if (this.isSwedishCustomer()) {
      return '25';
    }

    return '0';
  }

  private ensureInvoiceGroupDefaults(): void {
    if (!this.data || !this.data.invoiceItemGroup) {
      return;
    }

    if (!Array.isArray(this.data.invoiceItemGroup.InvoiceRows)) {
      this.data.invoiceItemGroup.InvoiceRows = [];
    }

    if ((!this.data.invoiceItemGroup.Type || typeof this.data.invoiceItemGroup.Type !== 'object')
      && !this.shouldAlwaysShowAllFields()) {
      this.data.invoiceItemGroup.Type = {};
    }

    if (!this.data.invoiceItemGroup.TimeReportStatus || typeof this.data.invoiceItemGroup.TimeReportStatus !== 'object') {
      this.data.invoiceItemGroup.TimeReportStatus = { DisplayName: "Ingen tid", Id: "3", Name: "NoInfo" };
      return;
    }

    const status = this.data.invoiceItemGroup.TimeReportStatus;
    if (!status.Name || String(status.Name).trim() === '') {
      status.Name = 'NoInfo';
    }

    if (!status.DisplayName || String(status.DisplayName).trim() === '') {
      status.DisplayName = status.Name === 'DetailedInfo'
        ? 'Detaljerad tid'
        : status.Name === 'SumTime'
          ? 'Summerad tid'
          : 'Ingen tid';
    }

    if (this.isWorkedHoursGroup() && !this.shouldAlwaysShowAllFields()) {
      this.data.invoiceItemGroup.Type = {
        ...(this.data.invoiceItemGroup.Type || {}),
        TechnicalName: 'WorkedHours',
        Name: 'Arbetad tid'
      };
      this.data.invoiceItemGroup.Description = 'Arbetad tid';
      this.data.invoiceItemGroup.Amount = 0;
    }
  }

  setVatList() {
    const allowedVatValues = (!this.isAdmin && this.isSwedishCustomer() && this.data.invoiceItemGroup && this.data.invoiceItemGroup.ReverseTax)
      ? ['0']
      : this.getAllowedVatValues();
    this.vatList = allowedVatValues.map(value => ({ Value: value }));

    if (!this.data.invoiceItemGroup) {
      return;
    }

    if (!this.isReverseTaxAllowed()) {
      this.data.invoiceItemGroup.ReverseTax = false;
    }

    const currentVat = this.data.invoiceItemGroup.Vat != null ? String(this.data.invoiceItemGroup.Vat) : '';
    this.data.invoiceItemGroup.Vat = allowedVatValues.includes(currentVat)
      ? currentVat
      : this.getDefaultVatValue();
  }

  private computeValidationState(): { canSave: boolean; message: string } {
    if (this.isWorkedHoursGroup() && this.requiresDetailedInfo() && !this.isDetailedInfoSelected()) {
      return {
        canSave: false,
        message: this.data.isRotRut
          ? "Vid RUT/ROT krävs att du visar detaljerad tid på din faktura."
          : "Denna kund kräver att du visar detaljerad tid på din faktura."
      };
    }

    if (this.isWorkedHoursGroup() && this.isTimeInfoSelected() && this.isInvoiceRowsEmpty()) {
      return {
        canSave: false,
        message: "Välj datum och tid för att visa på faktura. Befattning/titel/yrke måste anges."
      };
    }

    if (this.isWorkingTitleRequired() && this.isWorkingTitleEmpty()) {
      // Inline error message is shown under the field, so don't duplicate here.
      return { canSave: false, message: "" };
    }

    const description = this.data?.invoiceItemGroup?.Description || '';
    const shouldValidateDescription = !this.isWorkedHoursGroup() || (description && description.trim() !== '');
    if (shouldValidateDescription && !this.checkForbiddenSymbols(description)) {
      return {
        canSave: false,
        message: "Beskrivningen innehåller otillåtna tecken. Du behöver radera otillåtna tecken och tabbar. Godkänt innehåll är a-ö, A-Ö, 0-9 samt , . ! ( ) ? / -"
      };
    }

    return { canSave: true, message: "" };
  }

  updateValidationState(): boolean {
    const result = this.computeValidationState();
    this.ErrorMessageSend = result.message;
    this.canSave = result.canSave;
    return this.canSave;
  }

  requiresDetailedInfo(): boolean {
    return this.data.customer.TimeReportMandatory === true || this.data.isRotRut === true;
  }

  isDetailedInfoSelected(): boolean {
    return this.getTimeReportStatusName() === 'DetailedInfo';
  }

  isTimeInfoSelected(): boolean {
    const name = this.getTimeReportStatusName();
    return name === 'DetailedInfo' || name === 'SumTime';
  }

  isInvoiceRowsEmpty(): boolean {
    const rows = this.data.invoiceItemGroup.InvoiceRows;
    return !rows || rows.length === 0;
  }

  isWorkingTitleEmpty(): boolean {
    const title = this.data.invoiceItemGroup.WorkingTitle;
    return !title || title.trim() === '';
  }

  private getTimeReportStatusName(): string {
    const status = this.data && this.data.invoiceItemGroup ? this.data.invoiceItemGroup.TimeReportStatus : null;
    if (!status || typeof status.Name !== 'string') {
      return '';
    }
    return status.Name;
  }

  public quickRowValidate() {
    
    if (this.data.invoiceItemGroup.Description == '' || this.data.invoiceItemGroup.Description == ' ') {
      this.ErrorMessageTab = '';
    }

    this.checkForbiddenSymbols(this.data.invoiceItemGroup.Description);
    this.updateValidationState();

  }

  checkForbiddenSymbols(description: any) {

    var regex = /^[-a-öA-Ö0-9,./&€%;+:@!?()= \r\n]*[^|¤"–]$/g;
    var inputIsValid = regex.test(description);

    if (inputIsValid) {
      this.quickrowValid = true;
      this.ErrorMessageDesc = '';
      return true;
    }
    else {
      this.quickrowValid = false;
      return false;
    }
  }

  reverseTaxChange(group: any, value) {
    if (!this.isReverseTaxAllowed()) {
      this.data.invoiceItemGroup.ReverseTax = false;
      this.data.invoiceItemGroup.Vat = this.getDefaultVatValue();
      this.setVatList();
      this.updateValidationState();
      return;
    }

    this.data.invoiceItemGroup.ReverseTax = value.checked;
    this.data.invoiceItemGroup.Vat = value.checked ? "0" : this.getDefaultVatValue();
    this.setVatList();
    this.updateValidationState();
  }

  timeReportStatusChange(event: any)
  {
      console.log(event.value);

      for (var i = 0; i < this.timeReportStatuses.length; i++)
      {
          if (this.timeReportStatuses[i].Id == event.value)
          {
                  this.data.invoiceItemGroup.TimeReportStatus.Name = this.timeReportStatuses[i].Name;
          }
      }
      this.updateValidationState();
  }

  canEditGroup()
  {
    if (this.isAdmin) {
      return true;
    }
    else if (this.isWorkedHoursGroup()) {
      return this.data.canEditWorkedHours !== false;
    }
    else {
      let statuses = ["Draft", "OfferingRequested", "OfferingSent"];
      return statuses.includes(this.data.status);
    }
  }

  getTimeReportStatuses()
  {
      this.invoiceService.getTimeReportStatuses()
          .subscribe(
          response => this.getTimeReportStatusesFinished(response),
          error => console.log(error));
  }

  getTimeReportStatusesFinished(statuses: Array<ITimeReportStatus>)
  {
    setTimeout(() => {
      this.timeReportStatuses = statuses;
      this.timeReportStatusesLoaded = true;
      this.ensureInvoiceGroupDefaults();
      if (this.data.customer.TimeReportMandatory || this.data.isRotRut) {
        this.data.invoiceItemGroup.TimeReportStatus.Id = "1";
        this.data.invoiceItemGroup.TimeReportStatus.Name = "DetailedInfo";
        this.data.invoiceItemGroup.TimeReportStatus.DisplayName = "Detaljerad tid";
      }
      else {
        if (this.data.invoiceItemGroup.TimeReportStatus != null && this.data.invoiceItemGroup.TimeReportStatus.Id == null) {
          for (var i = 0; i < this.timeReportStatuses.length; i++) {
            if (this.timeReportStatuses[i].SortOrder == 1) {
              var status = this.timeReportStatuses[i];
              this.data.invoiceItemGroup.TimeReportStatus.Id = status.Id.toString();
              this.data.invoiceItemGroup.TimeReportStatus.Name = status.Name;
              this.data.invoiceItemGroup.TimeReportStatus.DisplayName = status.DisplayName;

            }
          }
        }
        else if (this.data.invoiceItemGroup.TimeReportStatus != null) {
          this.data.invoiceItemGroup.TimeReportStatus.Id = this.data.invoiceItemGroup.TimeReportStatus.Id.toString();
        }
      }

      this.updateValidationState();
      const viewRef = this.changeDetectorRef as ViewRef;
      if (!viewRef.destroyed) {
        this.changeDetectorRef.detectChanges();
      }
    }, 0);
        
  }

  updateTimeReportStatus() {

      // Don't do for the old rows
      if (this.data.invoiceItemGroup.TimeReportStatus != null) {
          let matchedById = false;

          for (var i = 0; i < this.timeReportStatuses.length; i++) {

              if (this.timeReportStatuses[i].Id.toString() == this.data.invoiceItemGroup.TimeReportStatus.Id) {

                  var status = this.timeReportStatuses[i];
                  this.data.invoiceItemGroup.TimeReportStatus.Name = status.Name;
                  this.data.invoiceItemGroup.TimeReportStatus.DisplayName = status.DisplayName;
                  matchedById = true;
              }
          }

          if (!matchedById && this.data.invoiceItemGroup.TimeReportStatus.Name) {
            const statusByName = this.timeReportStatuses.find(status => status.Name === this.data.invoiceItemGroup.TimeReportStatus.Name);
            if (statusByName) {
              this.data.invoiceItemGroup.TimeReportStatus.Id = statusByName.Id.toString();
              this.data.invoiceItemGroup.TimeReportStatus.DisplayName = statusByName.DisplayName;
            }
          }
      }

  }

  isWorkingTitleRequired(): boolean {
    return this.isWorkedHoursGroup();
  }

  shouldAlwaysShowAllFields(): boolean {
    return this.data?.alwaysShowAllFields === true;
  }

  shouldShowDescriptionFields(): boolean {
    return this.shouldAlwaysShowAllFields() || !this.isWorkedHoursGroup();
  }

  canEditGeneralFields(): boolean {
    if (this.isAdmin) {
      return true;
    }

    const statuses = ["Draft", "OfferingRequested", "OfferingSent"];
    return statuses.includes(this.data.status);
  }

  shouldShowFinancialFields(): boolean {
    return this.shouldAlwaysShowAllFields() || !this.isWorkedHoursGroup();
  }

  shouldShowMiscSection(): boolean {
    return !this.shouldAlwaysShowAllFields()
      && this.data?.invoiceItemGroup?.Type?.Name == 'Övrigt'
      && !this.isWorkedHoursGroup();
  }

  isInvoiceItemGroup(): boolean {
    const tech = this.data && this.data.invoiceItemGroup && this.data.invoiceItemGroup.Type
      ? String(this.data.invoiceItemGroup.Type.TechnicalName || '')
      : '';
    if (tech === 'InvoiceItem') {
      return true;
    }

    const name = this.data && this.data.invoiceItemGroup && this.data.invoiceItemGroup.Type
      ? String(this.data.invoiceItemGroup.Type.Name || '').toLowerCase()
      : '';
    return name === 'invoiceitem';
  }

  isWorkedHoursGroup(): boolean {
    if (this.data?.alwaysAllowWorkedHours === true) {
      return true;
    }

    const tech = this.data && this.data.invoiceItemGroup && this.data.invoiceItemGroup.Type
      ? String(this.data.invoiceItemGroup.Type.TechnicalName || '')
      : '';
    if (tech === 'WorkedHours') {
      return true;
    }

    const name = this.data && this.data.invoiceItemGroup && this.data.invoiceItemGroup.Type
      ? String(this.data.invoiceItemGroup.Type.Name || '').toLowerCase()
      : '';
    if (name === 'arbetad tid') {
      return true;
    }

    const type = this.data?.invoiceItemGroup?.Type;
    const hasExplicitType = type != null && (
      (type.Id != null && String(type.Id).trim() !== '')
      || (type.Value != null && String(type.Value).trim() !== '')
      || tech.trim() !== ''
      || name.trim() !== ''
    );
    if (hasExplicitType) {
      return false;
    }

    const description = this.data && this.data.invoiceItemGroup
      ? String(this.data.invoiceItemGroup.Description || '').toLowerCase()
      : '';
    if (description === 'arbetad tid') {
      return true;
    }

    const rows = this.data && this.data.invoiceItemGroup && Array.isArray(this.data.invoiceItemGroup.InvoiceRows)
      ? this.data.invoiceItemGroup.InvoiceRows
      : [];
    return rows.length > 0;
  }


  rowTypeChange(event: any)
  {
      this.data.invoiceItemGroup.Type = this.getRowType(event.value);
        
      if (event.value == "Övrigt")
      {
          // No rows allowed in the misc category
          this.data.invoiceItemGroup.InvoiceRows = [];
      }
  }

  getRowType(id: any)
  {
      for (var i = 0; i < this.rowTypeList.length; i++)
      {
          if (this.rowTypeList[i].Name == id)
          {
              return { Id: this.rowTypeList[i].Id, Name: this.rowTypeList[i].Name};
          }
      }
  }

  saveCalendar()
  {
      this.applyWorkCountryToGroup();
      this.ensureInvoiceGroupDefaults();
      console.log(this.data.invoiceItemGroup);

      this.dialogRef.close(this.data.invoiceItemGroup);
  }

  saveRow(event?: MouseEvent) {
      if (this.saveSubmitted) {
        event?.preventDefault();
        event?.stopPropagation();
        return;
      }

      this.saveSubmitted = true;
      this.isSaving = true;
      const saveButton = event?.currentTarget as HTMLButtonElement | null;
      if (saveButton) {
        saveButton.disabled = true;
      }
      if (!this.canEditGroup()) {
        this.saveSubmitted = false;
        this.isSaving = false;
        if (saveButton) {
          saveButton.disabled = false;
        }
        return;
      }
      if (!this.updateValidationState()) {
        this.saveSubmitted = false;
        this.isSaving = false;
        if (saveButton) {
          saveButton.disabled = false;
        }
        return;
      }
      this.applyWorkCountryToGroup();
      this.ensureInvoiceGroupDefaults();
      this.data.invoiceItemGroup.isNew = false;
      this.updateTimeReportStatus();
      if (!(this.changeDetectorRef as ViewRef).destroyed) {
        this.changeDetectorRef.detectChanges();
      }
      window.setTimeout(() => this.dialogRef.close(this.data.invoiceItemGroup), 150);
  }
  
  deleteRow()
  {
      if (!this.canEditGroup()) {
        return;
      }
      this.data.invoiceItemGroup.action = 'delete';
      this.dialogRef.close(this.data.invoiceItemGroup);
  }    

  cancel()
  {
      this.dialogRef.close(undefined);
  }
    
  deleteListItem(item: any)
  {
      if (!this.canEditGroup()) {
        return;
      }
      console.log(item);

      this.data.invoiceItemGroup.InvoiceRows.splice(this.data.invoiceItemGroup.InvoiceRows.indexOf(item), 1);
      this.updateValidationState();
  }

  guid() {  
      return this.s4() + this.s4() + '-' + this.s4() + '-' + this.s4() + '-' + this.s4() + '-' + this.s4() + this.s4() + this.s4();
  }

  s4() {
      return Math.floor((1 + Math.random()) * 0x10000)
          .toString(16)
          .substring(1);
  }
    
  calendarSelect(dateString: string)
  {
      if (!this.canEditGroup()) {
        return;
      }

      var date = this.toFormattedDate(dateString);
      if (!date) {
        return;
      }
      const normalizedDate = this.normalizeDateOnly(date);
         
      // Duplicate dates not allowed
      for (var i = 0; i < this.data.invoiceItemGroup.InvoiceRows.length; i++)
      {
          var item = this.data.invoiceItemGroup.InvoiceRows[i];
          const existingDate = this.normalizeDateOnly(item.StartDate);

          if (existingDate === normalizedDate)
          {
              return;
          }
      }

      // Add item
      this.data.invoiceItemGroup.InvoiceRows.push({ StartDate: normalizedDate, Id: this.guid(), HoursWorked: this.hoursSelected, MinutesWorked: this.minutesSelected });

      // Sort list by date
      this.data.invoiceItemGroup.InvoiceRows.sort((val1: any, val2: any) => {
          var d1 = <any>new Date(val1.StartDate.toString());
          var d2 = <any>new Date(val2.StartDate.toString());
            
          return d1 - d2;
      })
      this.updateValidationState();
      const viewRef = this.changeDetectorRef as ViewRef;
      if (!viewRef.destroyed) {
        this.changeDetectorRef.detectChanges();
      }
        
  }

  toFormattedDate(iso: string) {

      const date = new Date(iso);

      var d = `${date.getFullYear()}-${(date.getMonth() + 1).toString().length == 1 ? ('0' + (date.getMonth() + 1)) : date.getMonth() + 1}-${date.getDate().toString().length == 1 ? ("0" + date.getDate().toString()) : date.getDate().toString()}`;

      if (d == '1970-01-01')
          return undefined;

      return d;
  }

  private normalizeDateOnly(value: any): string | undefined {
    if (value == null || value === '') {
      return undefined;
    }

    const asString = String(value);
    const match = asString.match(/^(\d{4}-\d{2}-\d{2})/);
    if (match && match[1]) {
      return match[1];
    }

    return this.toFormattedDate(asString);
  }

    
  onError(error: any)
  {
      alert('An error occured');
      console.log(error);
  }
    
}



